<template>
  <span>
    <slot></slot>
  </span>
</template>
<script>
export default {
  props: ['tooltipText'],
  created() {
    // Non-reactive on purpose: wrapping Bootstrap Tooltip instances in a Vue
    // reactive proxy breaks their internal identity checks on dispose().
    this.tooltipInstances = []
    this.tooltipTimer = null
    this.isUnmounted = false
  },
  async mounted() {
    const { default: Tooltip } = await import('bootstrap/js/dist/tooltip')
    // The import is async, so the component can unmount before it resolves. 
    if (this.isUnmounted) return
    // Delay lets any enter animation settle before positioning the tooltip.
    this.tooltipTimer = setTimeout(() => {
      // Scope to this component's own DOM
      this.tooltipInstances = Array.from(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'))
        .map(tooltipNode => new Tooltip(tooltipNode))
    }, 300)
  },
  beforeUnmount() {
    // Signals the awaited init in mounted() to bail if it resolves after this.
    this.isUnmounted = true
    // Cancel a pending init so we never instantiate on detached nodes.
    if (this.tooltipTimer) {
      clearTimeout(this.tooltipTimer)
      this.tooltipTimer = null
    }
    // Removes popper node from <body>.
    this.tooltipInstances.forEach(instance => instance.dispose())
    this.tooltipInstances = []
  },
}
</script>

<style lang="scss">
  @import "lendio-tooltips";
  $tooltip-max-width: 400px;
  .tooltip-inner {
    max-width: $tooltip-max-width;
    text-align: left;
  }
</style>
